import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { API_URL_COMPANIES } from 'src/app/shared/services/basic.service';
import { ErrorHandlingService } from 'src/app/shared/services/error-handling.service';

import { ActionType, SendByEmailPayload } from '../../task-process/archive-and-other-actions/models';
import { SendByEmailSettings } from '../models/send-by-mail';

@Injectable({
  providedIn: 'root',
})
export class SendConversationByEmailService {
  constructor(
    private alcmeonContext: AlcmeonContextService,
    private errorHandlingService: ErrorHandlingService,
    private http: HttpClient
  ) {}

  getSettings(): Observable<SendByEmailSettings[]> {
    return this.http
      .get<SendByEmailSettings[]>(
        `${API_URL_COMPANIES}/${this.alcmeonContext.companyId}/parameters/outgoing-emails/?type=${ActionType.sendConversation}`
      )
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  saveSettings(data: SendByEmailSettings): Observable<SendByEmailSettings[]> {
    return this.http
      .put<SendByEmailSettings[]>(
        `${API_URL_COMPANIES}/${this.alcmeonContext.companyId}/parameters/outgoing-emails/?type=${ActionType.sendConversation}`,
        data
      )
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  sendEmail(data: SendByEmailPayload): Observable<any> {
    const { siteId, taskId } = data;
    return this.http
      .post<any>(
        `${API_URL_COMPANIES}/${this.alcmeonContext.companyId}/sites/${siteId}/tasks/${taskId}/outgoing-emails`,
        data
      )
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }
}
